import { addConnectionAemEnvironmentConnection } from '@owc/connection-aem-environment';
import { addTrackingReducerConnection } from '@owc/connection-aem-tracking';
import {
  initializeComponentRegistry,
  connectionName as componentConnectionName,
} from '@owc/component-registry-connection';
import { setMainNamespace } from '@seamless/router';
import { initializeStore } from '@seamless/store';
import { AEMManifest } from './manifest-interface';
import { addConnectionWkoManager, initializeWkoManager } from '@owc/connection-wko-manager';
declare const VERSION: string;
declare const ENV: string;
const logprefix = `GLOBALS ${VERSION}`;
// eslint-disable-next-line no-undef
export const version = VERSION;
const store = initializeStore();

addTrackingReducerConnection();
addConnectionAemEnvironmentConnection();
addConnectionWkoManager();
console.log(`${logprefix} initialize aem env`);
initializeComponentRegistry();
console.log(`${logprefix} initialize component registry`);

initializeWkoManager();
console.log(`${logprefix} initialize wko manager`);
/**
 * @todo read the given main routing component by aem cehckbox and set the mainnamespace on the router
 **/
store.subscribe(componentConnectionName, (state: { [key: string]: any }) => {
  if (state.components) {
    const keys = Object.keys(state.components);
    keys.forEach((key) => {
      const item: AEMManifest = state.components[key];
      // sometimes booleans are not booleans
      if (item.config && item.config.routingEnabled) {
        console.log(`${logprefix} main namespace found ${item.config.routerNamespace}`);
        setMainNamespace(item.config.routerNamespace as string);
      }
    });
  }
});
